import { FC } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { ApptRequestListItemSkeleton } from './appt-request-list-item/appt-request-list-item.skeleton';
import { ApptRequestListWrapper } from './appt-request-list.styles';

export const ApptRequestsListSkeleton: FC = () => {
  return (
    <ApptRequestListWrapper>
      <Scrollbars autoHide>
        {Array.from({ length: 5 }).map((_, index) => (
          <ApptRequestListItemSkeleton key={index} />
        ))}
      </Scrollbars>
    </ApptRequestListWrapper>
  );
};
